import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import './styles/UserMenu.css';

const UserMenu = () => {
    const { user, logout } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const [userInitial, setUserInitial] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (user && user.username) {
            setUserInitial(user.username.charAt(0).toUpperCase());
        }
    }, [user]);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const handleLogout = () => {
        logout();
        window.location.href = '/login'; // Redirect to login page after logout
    };

    const handleResetPassword = () => {
        navigate(`/resetpassword`);
    };

    // Ensure user and username are defined before accessing username.charAt(0)
    //const userInitial = user && user.username ? user.username.charAt(0).toUpperCase() : '';

    return (
        <div className="user-menu">
            <div className="user-icon" onClick={toggleMenu}>
                {userInitial}
            </div>
            {isOpen && (
                <div className="dropdown-menu">
                    <ul>
                        <li>My Profile</li>
                        <li onClick={handleResetPassword}>Reset Password</li>
                        <li onClick={handleLogout}>Logout</li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
